import { imageMapping } from './imageMapping';

export const menuData = {
  // MENÚ DEL DÍA
  menuDelDia: {
    title: 'MENÚ DE LA CASA',
    description: 'Disfruta de nuestro menú diario con opciones variadas y deliciosas.',
    priceLaborales: '18€',
    priceFestivos: '20€',
    schedule: '13:00 a 15:30 H',
    includes: 'Pan, Vino, Agua, 1/3 de Cerveza o 1 Refresco',
    supplement: 'Suplemento Menú Terraza 1€',
    notes: 'IVA INCLUIDO. Si dispone de alguna alergia o intolerancia, por favor, ponerse en contacto con el camarero',
    primeros: [
      { nameKey: 'md_plato_del_dia', originalName: 'Plato del Día', price: undefined },
      { nameKey: 'md_alcachofas_jamon', originalName: 'Alcachofas con Jamón', price: undefined },
      { nameKey: 'md_guisantes_jamon', originalName: 'Guisantes con Jamón', price: undefined },
      { nameKey: 'md_judias_jamon', originalName: 'Judías con Jamón', price: undefined },
      { nameKey: 'md_arroz_cubana', originalName: 'Arroz a la Cubana', price: undefined },
      { nameKey: 'md_macarrones_atun_tomate', originalName: 'Macarrones con Atún y Tomate', price: undefined },
      { nameKey: 'md_ensalada_mixta', originalName: 'Ensalada Mixta', price: undefined },
      { nameKey: 'md_ensalada_frutos_secos', originalName: 'Ensalada de Frutos Secos con rulo de Cabra', price: undefined },
      { nameKey: 'md_entremeses', originalName: 'Entremeses', price: undefined },
      { nameKey: 'md_gazpacho', originalName: 'Gazpacho (Temporada)', price: undefined },
      { nameKey: 'md_lunes_cocido', originalName: 'LUNES: Cocido Completo (solo por encargo)', price: undefined, highlight: true },
    ],
    segundos: [
      { nameKey: 'md_lomo_cerdo', originalName: 'Lomo de Cerdo', price: undefined },
      { nameKey: 'md_solomillo_cerdo', originalName: 'Solomillo de Cerdo (a la Plancha o Roquefort)', price: undefined },
      { nameKey: 'md_pechuga_pollo_plancha', originalName: 'Pechuga de Pollo a la Plancha', price: undefined },
      { nameKey: 'md_escalope_pollo', originalName: 'Escalope de Pollo', price: undefined },
      { nameKey: 'md_huevos_patatas', originalName: 'Huevos con Patatas', price: undefined },
      { nameKey: 'md_huevos_farinato', originalName: 'Huevos con Farinato', price: undefined },
      { nameKey: 'md_huevos_chorizo', originalName: 'Huevos con Chorizo', price: undefined },
      { nameKey: 'md_calamares_romana', originalName: 'Calamares a la Romana', price: undefined },
      { nameKey: 'md_pescado_del_dia', originalName: 'Pescado del Día', price: undefined },
    ],
    postres: [
      { nameKey: 'md_natillas', originalName: 'Natillas', price: undefined },
      { nameKey: 'md_cuajada', originalName: 'Cuajada', price: undefined },
      { nameKey: 'md_crema_queso_arandanos', originalName: 'Crema de Queso con mermelada de Arándanos', price: undefined },
      { nameKey: 'md_helado', originalName: 'Helado', price: undefined },
      { nameKey: 'md_fruta_tiempo', originalName: 'Fruta del tiempo', price: undefined },
    ],
  },

  // MENÚ INFANTIL
  menuInfantil: {
    title: 'MENÚ INFANTIL',
    description: 'Opciones deliciosas y adaptadas para los más pequeños de la casa.',
    price: '8€',
    schedule: '13:00 a 15:30 H',
    includes: 'Pan y Agua',
    supplement: 'Suplemento Menú Terraza 1€',
    notes: 'IVA INCLUIDO. Si dispone de alguna alergia o intolerancia, por favor, ponerse en contacto con el camarero',
    primeros: [
      { nameKey: 'mi_macarrones_tomate', originalName: 'Macarrones con Tomate', price: undefined },
      { nameKey: 'mi_arroz_cubana', originalName: 'Arroz a la Cubana', price: undefined },
      { nameKey: 'mi_sopa_cocido', originalName: 'Sopa de Cocido', price: undefined },
    ],
    segundos: [
      { nameKey: 'mi_huevo_patatas', originalName: 'Huevo con Patatas', price: undefined },
      { nameKey: 'mi_escalope_pollo_patatas', originalName: 'Escalope de Pollo con Patatas', price: undefined },
      { nameKey: 'mi_lomo_cerdo_patatas', originalName: 'Lomo de cerdo con Patatas', price: undefined },
    ],
    postres: [
      { nameKey: 'mi_natillas', originalName: 'Natillas', price: undefined },
      { nameKey: 'mi_helado', originalName: 'Helado', price: undefined },
      { nameKey: 'mi_fruta_tiempo', originalName: 'Fruta del tiempo', price: undefined },
    ],
  },

  // CARTA GENERAL - ENTRANTES
  entrantes: [
    { nameKey: 'cg_consome', originalName: 'Consomé', price: '3,00€' },
    { nameKey: 'cg_consome_yema', originalName: 'Consomé con Yema', price: '4,00€' },
    { nameKey: 'cg_sopa_cocido', originalName: 'Sopa de Cocido', price: '6,00€' },
    { nameKey: 'cg_crepe_farinato', originalName: 'Crep de Farinato', price: '3,50€' },
    { nameKey: 'cg_plato_dia', originalName: 'Plato del Día', price: '7,50€' },
    { nameKey: 'cg_gazpacho', originalName: 'Gazpacho (Temporada)', price: '6,00€' },
    { nameKey: 'cg_entremeses', originalName: 'Entremeses', price: '7,50€' },
    { nameKey: 'cg_guisantes_jamon', originalName: 'Guisantes con Jamón', price: '7,00€' },
    { nameKey: 'cg_alcachofas_jamon', originalName: 'Alcachofas con Jamón', price: '7,50€' },
    { nameKey: 'cg_revuelto_gambas', originalName: 'Revuelto de Gambas', price: '10,00€' },
    { nameKey: 'cg_revuelto_champinones_gambas', originalName: 'Revuelto de Champiñones y Gambas', price: '10,50€' },
    { nameKey: 'cg_revuelto_trigueros_gambas', originalName: 'Revuelto de Trigueros y Gambas', price: '10,50€' },
    { nameKey: 'cg_morcilla_arroz_pimientos', originalName: 'Morcilla de Arroz con Pimientos', price: '8,00€' },
  ],

  // CARTA GENERAL - ENSALADAS
  ensaladas: [
    { nameKey: 'cg_ensalada_normal', originalName: 'Ensalada Normal', price: '5,00€' },
    { nameKey: 'cg_ensalada_mixta', originalName: 'Ensalada Mixta', price: '8,00€' },
    { nameKey: 'cg_ensalada_naranja', originalName: 'Ensalada de Naranja', price: '9,00€' },
    { nameKey: 'cg_ensalada_frutos_secos', originalName: 'Ensalada de Frutos Secos con Rulo de Cabra', price: '10,00€' },
    { nameKey: 'cg_ensalada_tomate_mozzarella', originalName: 'Ensalada de Tomate con Queso Mozzarella', price: '8,50€' },
    { nameKey: 'cg_esparragos_blancos', originalName: 'Espárragos Blancos', price: '8,00€' },
  ],

  // CARTA GENERAL - IBÉRICOS
  ibericos: [
    { nameKey: 'cg_racion_queso_curado', originalName: 'Ración de Queso Curado', price: '8,50€' },
    { nameKey: 'cg_racion_chorizo_iberico', originalName: 'Ración de Chorizo Ibérico', price: '9,00€' },
    { nameKey: 'cg_racion_salchichon_iberico', originalName: 'Ración de Salchichón Ibérico', price: '9,00€' },
    { nameKey: 'cg_racion_lomo_iberico', originalName: 'Ración de Lomo Ibérico', price: '12,00€' },
    { nameKey: 'cg_tabla_surtida_ibericos', originalName: 'Tabla Surtido de Ibéricos', price: '20,00€' },
    { nameKey: 'cg_racion_pan', originalName: 'Ración de Pan', price: '0,80€' },
  ],

  // CARTA GENERAL - CARNES
  carnes: [
    { nameKey: 'cg_ternera_plancha', originalName: 'Ternera a la Plancha con Patatas', price: '10,00€' },
    { nameKey: 'cg_escalope_ternera', originalName: 'Escalope de Ternera con Patatas', price: '12,00€' },
    { nameKey: 'cg_lomo_cerdo', originalName: 'Lomo de Cerdo con Patatas', price: '8,00€' },
    { nameKey: 'cg_solomillo_cerdo_plancha', originalName: 'Solomillo de Cerdo a la plancha', price: '9,00€' },
    { nameKey: 'cg_solomillo_cerdo_roquefort', originalName: 'Solomillo de Cerdo con Salsa Roquefort', price: '11,00€' },
    { nameKey: 'cg_pechuga_pollo_plancha', originalName: 'Pechuga de Pollo a la plancha con patatas', price: '8,50€' },
    { nameKey: 'cg_escalope_pollo', originalName: 'Escalope de Pollo con patatas', price: '10,00€' },
    { nameKey: 'cg_chuletillas_cordero', originalName: 'Chuletillas de Cordero con patatas', price: '18,00€' },
    { nameKey: 'cg_entrecot', originalName: 'Entrecot con patatas', price: '19,00€' },
    { nameKey: 'cg_chuleton', originalName: 'Chuletón con patatas y pimientos', price: '29,00€' },
    { nameKey: 'cg_callos_chorizo', originalName: 'Callos con Chorizo al estilo Cata', price: '7,50€' },
    { nameKey: 'cg_morros_ternera', originalName: 'Morros de Ternera Rebozados', price: '8,00€' },
  ],

  // CARTA GENERAL - PESCADOS
  pescados: [
    { nameKey: 'cg_calamares_romana', originalName: 'Calamares a la Romana', price: '10,00€' },
    { nameKey: 'cg_sepia_plancha', originalName: 'Sepia a la Plancha', price: '12,50€' },
    { nameKey: 'cg_pescado_dia', originalName: 'Pescado del Día', price: 's/m' },
    { nameKey: 'cg_gambas_ajillo', originalName: 'Gambas Ajillo', price: '14,00€' },
  ],

  // CARTA GENERAL - PLATOS COMBINADOS
  platosCombinados: [
    { nameKey: 'cg_pc_1', originalName: 'Nº1. Huevos con Farinato y Patatas', price: '8,00€' },
    { nameKey: 'cg_pc_2', originalName: 'Nº2. Huevos con Bacon y Patatas', price: '8,00€' },
    { nameKey: 'cg_pc_3', originalName: 'Nº3. Huevos con Chorizo y Patatas', price: '9,00€' },
    { nameKey: 'cg_pc_4', originalName: 'Nº4. Huevos con Jamón y Patatas', price: '10,00€' },
    { nameKey: 'cg_pc_5', originalName: 'Nº5. Lomo, Bacon, Huevo y Patatas', price: '10,50€' },
    { nameKey: 'cg_pc_6', originalName: 'Nº6. Lomo, Tortilla, Espárragos y Patatas', price: '11,50€' },
    { nameKey: 'cg_pc_7', originalName: 'Nº7. Pechuga, Huevo, Bacon y Patatas', price: '10,00€' },
    { nameKey: 'cg_pc_8', originalName: 'Nº8. Ternera, Huevo, Bacon y Patatas', price: '12,00€' },
    { nameKey: 'cg_pc_9', originalName: 'Nº9. Escalope de Ternera, Huevo y Patatas', price: '14,00€' },
    { nameKey: 'cg_pc_10', originalName: 'Nº10. Tortilla Francesa, Calamares y Patatas', price: '11,50€' },
    { nameKey: 'cg_pc_11', originalName: 'Nº11. Tortilla Francesa con Patatas', price: '7,00€' },
    { nameKey: 'cg_pc_12', originalName: 'Nº12. Tortilla Francesa con Jamón y Patatas', price: '9,00€' },
    { nameKey: 'cg_pc_13', originalName: 'Nº13. Tortilla Francesa con Atún y Patatas', price: '9,00€' },
    { nameKey: 'cg_pc_14', originalName: 'Nº14. Huevos con Patatas', price: '7,00€' },
    { nameKey: 'cg_pc_15', originalName: 'Nº15. Sándwich Mixto', price: '6,00€' },
    { nameKey: 'cg_pc_16', originalName: 'Nº16. Sándwich de la Casa', price: '7,50€' },
  ],

  // CARTA BARRA - PINCHOS
  cartaBarraPinchos: [
    { nameKey: 'cb_crepe_farinato', originalName: 'Crepe de farinato', price: '3,50€' },
    { nameKey: 'cb_entremeses', originalName: 'Entremeses', price: '7,50€' },
    { nameKey: 'cb_guisantes_jamon', originalName: 'Guisantes con Jamón', price: '7,00€' },
    { nameKey: 'cb_alcachofas_jamon', originalName: 'Alcachofas con Jamón', price: '7,50€' },
    { nameKey: 'cb_revuelto_gambas', originalName: 'Revuelto de Gambas', price: '10,00€' },
    { nameKey: 'cb_revuelto_champinones_gambas', originalName: 'Revuelto de Champiñones y Gambas', price: '10,50€' },
    { nameKey: 'cb_revuelto_trigueros_gambas', originalName: 'Revuelto de Trigueros y Gambas', price: '10,50€' },
    { nameKey: 'cb_morcilla_arroz_pimientos', originalName: 'Morcilla de Arroz con pimientos', price: '8,00€' },
    { nameKey: 'cb_calamares_romana', originalName: 'Calamares a la Romana', price: '10,00€' },
    { nameKey: 'cb_gambas_ajillo', originalName: 'Gambas al ajillo', price: '14,00€' },
    { nameKey: 'cb_sepia_plancha', originalName: 'Sepia a la Plancha', price: '12,50€' },
    { nameKey: 'cb_callos_cata', originalName: 'Callos al estilo Cata', price: '7,50€' },
    { nameKey: 'cb_morros_ternera', originalName: 'Morros de Ternera Rebozados', price: '8,00€' },
  ],

  // CARTA BARRA - IBÉRICOS
  cartaBarraIbericos: [
    { nameKey: 'cb_racion_queso_curado', originalName: 'Ración de Queso Curado', price: '8,50€' },
    { nameKey: 'cb_racion_chorizo_iberico', originalName: 'Ración de Chorico Iberico', price: '9,00€' },
    { nameKey: 'cb_racion_salchichon_iberico', originalName: 'Ración de Salchichón Ibérico', price: '9,00€' },
    { nameKey: 'cb_racion_lomo_iberico', originalName: 'Ración de Lamo Iberico', price: '12,00€' },
    { nameKey: 'cb_tabla_surtida_ibericos', originalName: 'Tabla Surtida de Ibericos', price: '20,00€' },
  ],

  // CARTA BARRA - MONTADITOS
  cartaBarraMontaditos: [
    { nameKey: 'cb_montadito_lomo', originalName: 'Lomo a la Plancha', price: '2,00€' },
    { nameKey: 'cb_montadito_pechuga', originalName: 'Pechuga de Pollo', price: '2,00€' },
    { nameKey: 'cb_montadito_bacon', originalName: 'Bacon a la Plancha', price: '2,00€' },
    { nameKey: 'cb_montadito_barbada', originalName: 'Barbada a la Plancha', price: '2,00€' },
  ],

  cartaPrincipalNotes: 'IVA incluido en los Precios. Suplemento de Terraza 0,20€/Consumición.',
  cartaBarraNotes: 'Cada ingrediente suplementario en el montadito tendrá un cargo de 0,50€',
};
